import { ICustomerApp } from "./CustomerApp";
import { IEntity } from "./Entity";

export interface ICustomer extends IEntity {
    CustomerRef?: string;
    SystemSectorID?: number;
    SystemCountryID?: number;
    CustomerSectorID?: number;
    CustomerCountryID?: number;
    EditionID?: number;
    OrgConfigID?: number;
    TestServerID?: number;
    LiveServerID?: number;

    Address?: string;
    NumberOfStaff?: string;
    Website?: string;
    OrgPhone?: string;

    PrimaryUserTitle?: string;
    PrimaryUserFirstname?: string;
    PrimaryUserSurname?: string;
    PrimaryUserEmail?: string;
    PrimaryUserPhone?: string;

    CustomerApps?: ICustomerApp[];
}

export class Customer implements ICustomer {
    public ID: number = 0;
    public Title: string = null;
    public CustomerRef?: string = null;
    public CustomerSectorID?: number = null;
    public CustomerCountryID?: number = null;
    public EditionID?: number = null;
    public OrgConfigID?: number = null;
    public SystemSectorID?: number = null;
    public SystemCountryID?: number = null;
    public TestServerID?: number = null;
    public LiveServerID?: number = null;

    public Address?: string = null;
    public NumberOfStaff?: string = null;
    public Website?: string = null;
    public OrgPhone?: string = null;

    public PrimaryUserTitle?: string = null;
    public PrimaryUserFirstname?: string = null;
    public PrimaryUserSurname?: string = null;
    public PrimaryUserEmail?: string = null;
    public PrimaryUserPhone?: string = null;

    public CustomerApps?: ICustomerApp[] = [];
}